import { Currency } from '@/core/currency/interfaces';

const MAD: Currency = {
    name: 'Moroccan Dirham',
    demonym: 'Moroccan',
    majorSingle: 'Dirham',
    majorPlural: 'Dirhams',
    codeNumeric: '504',
    symbol: 'DH',
    symbolNative: 'د.م.',
    minorSingle: 'Centime',
    minorPlural: 'Centimes',
    ISOdigits: 2,
    decimals: 2,
    numToBasic: 100,
    code: 'MAD',
    delimiters: {
        thousands: '.',
        decimal: ','
    }
};

export default MAD;
